import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { TranslateService } from "@ngx-translate/core";

/**
 * Encapsulates the Material SnackBar Service for consistent message styles (e.g. error).
 */
@Injectable({
	providedIn: "root",
})
export class SnackBarService {
	constructor(
		private readonly snackBar: MatSnackBar,
		private readonly translateService: TranslateService,
	) {}

	/**
	 * Takes translate error message string and displays error snackbar with OK button.
	 */
	public showError(error: string): void {
		this.snackBar.open(this.translateService.instant(error), "OK", { panelClass: "error-message", duration: 3000 });
	}

	/**
	 * Takes translate info message string and displays info snackbar, which disappears after a certain time.
	 */
	public showInfo(info: string): void {
		this.snackBar.open(this.translateService.instant(info), undefined, {
			duration: 4000,
			panelClass: "info-message",
		});
	}

	/**
	 * Dismisses the currently opened snackbar.
	 */
	public dismiss(): void {
		this.snackBar.dismiss();
	}
}
